import { useState } from "react"
import Mute from "components/icons/mute"
import Unmute from "components/icons/unmute"
import Share from "components/icons/share"
import ShareModal from "components/ShareModal"
import { useShortContext } from "contexts/ShortContext"
import { SHORT_CONFIG } from "constants/short"

export default function ShortControls({ item, displayed, currentIndex, listShort }) {
  const {
    muted,
    volume,
    showAll,
    setShowAll,
    handleToggleMute,
    handleVolumeChange,
    userInteracted,
    setUserInteracted
  } = useShortContext()

  const [isShow, setIsShow] = useState(false)
  const [linkShare, setLinkShare] = useState("")

  const handleShare = () => {
    setIsShow(true)
    const domain = window.location.origin
    setLinkShare(`${domain}/short?search=&id=${item?.id}&type=2`)
  }

  return (
    <>
      {/* Volume control */}
      <div className="absolute top-4 left-4 z-10 group flex items-center gap-2 border-[1.5px] border-white/10 rounded-full bg-white/12 backdrop-blur-[18px] p-2">
        <button onClick={handleToggleMute} aria-label="Toggle mute">
          {muted || volume === SHORT_CONFIG.MIN_VOLUME ? <Mute /> : <Unmute />}
        </button>

        <input
          className="
            w-24 h-1 appearance-none rounded-full
            bg-white/30
            transition-opacity
            hidden group-hover:block
            [&::-webkit-slider-thumb]:appearance-none
            [&::-webkit-slider-thumb]:w-3
            [&::-webkit-slider-thumb]:h-3
            [&::-webkit-slider-thumb]:bg-[#1363CC]
            [&::-webkit-slider-thumb]:rounded-full
            [&::-webkit-slider-thumb]:cursor-pointer
          "
          style={{
            background: `linear-gradient(to right, #1363CC ${volume * 100}%, rgba(255,255,255,0.3) ${volume * 100}%)`
          }}
          type="range"
          name="volume"
          min={SHORT_CONFIG.MIN_VOLUME}
          max={SHORT_CONFIG.MAX_VOLUME}
          step={SHORT_CONFIG.VOLUME_STEP}
          value={volume}
          onChange={(e) => {
            if (!userInteracted) setUserInteracted(true)
            handleVolumeChange(e)
          }}
          aria-label="Volume"
        />
      </div>

      {/* Video info */}
      <div className="absolute bottom-24 left-0 right-0 px-4 text-white z-10">
        <p className="text-base font-bold line-clamp-2">{listShort?.[currentIndex]?.name}</p>

        <TagList
          tags={displayed}
          showAll={showAll}
          totalTags={listShort?.[currentIndex]?.tag?.length}
          onToggle={setShowAll}
        />

        <p className="flex justify-end">
          <button onClick={handleShare} aria-label="Share">
            <Share />
          </button>
        </p>
      </div>

      <ShareModal isOpen={isShow} onCancel={() => setIsShow(false)} linkShare={linkShare} />
    </>
  )
}

// Separate TagList component for better readability
function TagList({ tags, showAll, totalTags, onToggle }) {
  if (!Array.isArray(tags) || tags.length === 0) return null

  return (
    <p className="text-base font-bold text-gray-300 mt-1">
      {tags.map((tag, index) => (
        <span key={tag?.id || index} className="mr-1">
          #{tag?.name}
        </span>
      ))}

      {totalTags > 3 && (
        <span onClick={() => onToggle((prev) => !prev)} className="text-white cursor-pointer hover:underline">
          {showAll ? (
            <>
              <br /> Ẩn bớt
            </>
          ) : (
            "...Xem thêm"
          )}
        </span>
      )}
    </p>
  )
}
